
namespace Matrix.Workflow {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter])
    export class StatusCodeFormatter implements Serenity.ISlickFormatter {
        format(ctx: Slick.FormatterContext) {
            if (!ctx.value)
                return "";

            var color;
            if (ctx.value === "PASS" || ctx.value === "SUCCEEDED" || ctx.value === "APPROVED" || ctx.value === "COMPLETED")
                color = "green";
            else if (ctx.value === "FAIL" || ctx.value === "FAILED" || ctx.value === "REJECTED" || ctx.value ==="FAILED_DATAQUALITY_CHECKS")
                color = "red";
            else if (ctx.value == "WARN" || ctx.value == "WARNING")
                color = "orange";
            else if (ctx.value == "IGNORE")
                color = "gray";
            else
                color = "black";

            return `<span class="text-${color}"><i class="fa fa-circle"></i> ${Q.htmlEncode(ctx.value)}</span>`;
        }
    }
}